import { PATH_ROUTING } from 'src/app/shared/enums/routing-enums';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { EventManagerService } from 'src/app/core/services/event-manager.service';
import { Spinner } from 'src/app/core/services/spinner.service';
import { ConfirmationDialogComponent } from 'src/app/shared/components/dialog/confirmation-dialog.component';
import { MESSAGE_TOAST } from 'src/app/shared/enums/message-toast-enum';
import { ApplicationTrainingDocument } from 'src/app/shared/model/application-training-document.model';
import { ActionTrainingDocumentService } from 'src/app/shared/service/action-training-document.service';
import { AdminService } from 'src/app/shared/service/admin.service';
import { ApplicationTrainingDocumentDetailService } from 'src/app/shared/service/application-training-document-detail.service';
import { DialogSupportDetailComponent } from './dialog-support-detail/dialog-support-detail.component';
import { RSP_ROLES } from 'src/app/shared/enums/admin-enum';
import { API_URL } from 'src/app/shared/enums/api-enums';

export enum ADMINTYPE {
  GE_CONFIFENTIAL_DOCUMENTS = 'ge-confidential-documents-admin',
  APPLICATION_TRAINING_DOCUMENT = 'application-training-document-admin',
}

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {
  isShow = true;
  isMobile = false;
  width: number = window.innerWidth;
  mobileWidth = 760;
  admin = new FormControl(null, Validators.required);
  admins = [];
  roles: string;
  applicationDocumentList: ApplicationTrainingDocument[] = [];
  type = '';
  APIType = '';
  constructor(
    private dialog: MatDialog,
    private spinner: Spinner,
    private service: AdminService,
    private documentService: ApplicationTrainingDocumentDetailService,
    private documentActionService: ActionTrainingDocumentService,
    private toast: ToastrService,
    private eventManager: EventManagerService,
    private router: Router,
  ) {
    this.router.events.filter(event => event instanceof NavigationEnd)
      .subscribe((res: any) => {
        this.type = res.urlAfterRedirects.split('/')[3];
        if (this.type === ADMINTYPE.APPLICATION_TRAINING_DOCUMENT) {
          this.APIType = API_URL.APPLICATION_TRAINING_URL;
        } else {
          this.APIType = API_URL.CONFIDENTIAL;
        }
      });
  }

  ngOnInit(): void {
    this.eventManager.subscribe('SHOW_SIDEBAR', (res) => {
      this.isShow = res.data.isShow;
    });
    this.isMobile = this.width < this.mobileWidth;
    this.roles = atob(localStorage.getItem(btoa('role')));
    if (this.roles.split(',').some(r => r === RSP_ROLES.ADMIN)) {
      this.getAdmins();
    }
    this.getApplicatiponTrainingDocuments();
  }

  getAdmins() {
    this.spinner.show();
    this.service.getAdmin().subscribe((res) => {
      this.admins = res.data;
      this.spinner.hide();
    });
  }

  getApplicatiponTrainingDocuments() {
    this.spinner.show();
    this.documentService.getApplicationTrainingDocument(this.APIType).subscribe((res) => {
      this.spinner.hide();
      this.applicationDocumentList = res.data;
    });
  }

  onWindowResize(event) {
    this.width = event.target.innerWidth;
    this.isMobile = this.width < this.mobileWidth;
    if (this.width < this.mobileWidth) {
      this.isShow = true;
    }
  }

  addAdmin() {
    if (!this.admin.valid) {
      this.admin.markAsTouched();
      return;
    } else {
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        data: {
          message: MESSAGE_TOAST.CONFIRM_ADD_ADMIN,
          buttonText: {
            ok: 'Yes',
            cancel: 'No'
          }
        }
      });
      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          const index = this.admins.findIndex(item2 => item2 === this.admin.value);
          if (index !== -1) {
            this.toast.error(MESSAGE_TOAST.ERROR_ADMIN_EXIST);
          } else {
            this.spinner.show();
            this.service.postAdmin(this.admin.value).subscribe((res) => {
              this.admin = new FormControl(null, Validators.required);
              this.admins = res.data;
              this.spinner.hide();
              this.toast.success(MESSAGE_TOAST.ADD_ADMIN_SUCCESS);
            }, (err) => {
              this.spinner.hide();
            });
          }
        }
      });
    }
  }

  checkValueAdmin() {
    const admin = this.admin.value.replace(/[^0-9]/g, '');
    this.admin.setValue(admin);
  }

  openDialog(data?, type?) {
    const dialogRef = this.dialog.open(DialogSupportDetailComponent, {
      width: '70%',
      maxHeight: '500px',
      data: {
        type: type ? 'edit' : 'add',
        body: data ? data : null,
      }
    });
    dialogRef.afterClosed().subscribe((res) => {
      this.getApplicatiponTrainingDocuments();
    });
  }

  delete(id) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: MESSAGE_TOAST.CONFIRM_DELETE_APPLICATION,
        buttonText: {
          ok: 'Yes',
          cancel: 'No'
        }
      }
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.spinner.show();
        this.documentActionService.deleteApplication(id, this.APIType).subscribe((res) => {
          this.spinner.hide();
          if (res.data) {
            const index = this.applicationDocumentList.findIndex(item2 => item2.id === id);
            if (index !== -1) {
              this.applicationDocumentList.splice(index, 1);
            }
            this.toast.success(MESSAGE_TOAST.DELETE_APPLICATION_SUCCESS);
          } else {
            this.toast.error('Delete Application Fail');
          }
        }, (err) => {
          this.spinner.hide();
        });
      }
    });
  }

  setShowItem(item) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: MESSAGE_TOAST.CONFIRM_CHANGE_ACTIVE_APPLICATION,
        buttonText: {
          ok: 'Yes',
          cancel: 'No'
        }
      }
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.spinner.show();
        const isShow = !item.active;
        this.documentActionService.changeActiveApplication(item.id, isShow, this.APIType).subscribe((res) => {
          this.spinner.hide();
          item.active = !item.active;
          this.toast.success(isShow
            ? MESSAGE_TOAST.CHANGE_ACTIVE_APPLICATION_SUCCESS
            : MESSAGE_TOAST.CHANGE_ACTIVE_HIDDEN_APPLICATION_SUCCESS
          );
        }, (err) => {
          this.spinner.hide();
        });
      }
    });
  }

  openReadMe() {
    if (this.type === ADMINTYPE.APPLICATION_TRAINING_DOCUMENT) {
      window.open('../../../../../assets/pdf-register/ApplicationTrainingDocumentAdminUserManual.pdf');
    }
    if (this.type === ADMINTYPE.GE_CONFIFENTIAL_DOCUMENTS) {
      window.open('../../../../../assets/pdf-register/Confidential-Admin-User-Manual.pdf');
    }
  }

  addTrainingDocument() {
    if (this.type === ADMINTYPE.APPLICATION_TRAINING_DOCUMENT) {
      this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_ADMIN, PATH_ROUTING.PATH_TRAINING_DOCUMENT_ADMIN_ADD]);
    } else {
      this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_ADMIN, PATH_ROUTING.PATH_GE_CONFIDENTIAL_DOCUMENTS_ADMIN_ADD]);
    }
  }

  updateTrainingDocument(id) {
    if (this.type === ADMINTYPE.APPLICATION_TRAINING_DOCUMENT) {
      this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_ADMIN, 'edit-application-training-document', id]);
    } else {
      this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_ADMIN, 'edit-ge-confidential-documents', id]);
    }
  }
}
